import { isPlatformBrowser } from '@angular/common';
import {
    Component,
    Inject,
    OnDestroy,
    OnInit,
    PLATFORM_ID,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AuthModule } from './core/auth/auth.module';
import { OrganisationService } from './core/organisation/organisation.service';
import { PosthogService } from './core/posthog/posthog.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, AuthModule],
})
export class AppComponent implements OnInit, OnDestroy {
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    /**
     * Constructor
     */
    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private _organisationService: OrganisationService,
        posthogService: PosthogService
    ) {}

    ngOnInit(): void {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }

        // Update document title when organization changes
        this._organisationService.organisation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((org) => {
                const title = org?.name
                    ? `${org.name} - Creator Studio`
                    : 'wasmachen.at - Creator Studio';
                document.title = title;
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
